export default __webpack_public_path__ + "static/utlo-logo-69a4c5b295edb57d654a9dd5764bbda3.svg";